module.exports = __webpack_public_path__ + "static/media/I_lazy_ux.9ff0f364.png";